import React from 'react';

const ShippingPolicy = () => {
    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w mx-auto bg-white shadow-sm rounded-2xl overflow-hidden border border-slate-200">
                <div className="bg-slate-900 px-8 py-10 text-white">
                    <h1 className="text-3xl font-bold mb-2">Return & Shipping Policy</h1>
                    <p className="text-slate-400">Effective Date: February 23, 2026</p>
                </div>

                <div className="p-8 md:p-12 space-y-8 text-slate-700 leading-relaxed">
                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">1. Nature of Services</h2>
                        <p>
                            paperportal.in is a digital platform operated by <strong>Paper Portal</strong>. We specialize exclusively in professional digital services, including research consultancy, academic review management, and digital publishing tools.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">2. No Physical Shipping</h2>
                        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-xl">
                            <p className="font-medium text-blue-900">
                                As we do not deal in any physical products, there is <strong>no shipping involved</strong> in any of our transactions.
                            </p>
                        </div>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li>All services, reports, and communications are delivered electronically through our Website or via email.</li>
                            <li>There are no delivery charges or shipping costs associated with any of our services.</li>
                            <li>Delivery of services is considered complete once the digital output is accessible on your user dashboard or sent to your registered email.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">3. No Return or Exchange</h2>
                        <p>
                            Since our offerings are purely service-based and digital in nature:
                        </p>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li><strong>Return:</strong> There is no concept of a "return" as no physical goods are delivered.</li>
                            <li><strong>Exchange:</strong> Services cannot be exchanged for other services once the delivery has commenced or completion has occurred.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">4. Digital Delivery Timeline</h2>
                        <p>
                            The timeline for our digital services varies based on the specific service selected (e.g., abstract review, paper submission status). Estimated completion times will be visible on your dashboard or communicated at the time of service initiation.
                        </p>
                    </section>

                    <section className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                        <h2 className="text-xl font-bold text-slate-900 mb-4">5. Contact Information</h2>
                        <div className="space-y-2 text-sm md:text-base">
                            <p><strong>Company Name:</strong> Paper Portal</p>
                            <p><strong>Registered Address:</strong> 5 Bibhuti Bhusan Bandopadhay Sarani, Kolkata 700019, West Bengal, India</p>
                            <p><strong>Business Email:</strong> helpdesk@paperportal.in</p>
                            <p><strong>Support Email:</strong> payment@paperportal.in</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ShippingPolicy;
